import graphQLClient from "../../utils/authHeader";
import APPLY_TO_PARTNER_WHITELIST from "../../utils/mutations/pool/applyToPartnerWhitelist";
import APPLY_TO_POOL_WHITELIST from "../../utils/mutations/pool/applyToPoolWhitelist";
import userListPledge from "../../utils/queries/getUserPledge/userListPledge";
import GET_POOL_WHITELIST_STATE from "../../utils/queries/pool/getPoolWhitelistState";

export const POOL_STATUS = ['ongoing', 'whitelist_open', 'whitelist_closed', 'upcoming', 'canceled', 'closed'];

export type PoolStatus = 'ongoing' | 'whitelist_open' | 'whitelist_closed' | 'upcoming' | 'canceled' | 'closed';

export type PoolWhiteListProps = {
    poolId: string,
    networkId: number,
}

// TODO: Create pool interface
export const filterPoolByStatus = (pools: any[], status: PoolStatus[]) => {
    return pools.filter(pool => status.includes(pool.status));
}

export const getUserPledges = () => {
    return new Promise((resolve, reject) => {
        graphQLClient
        .request(userListPledge)
        .then((data: any) => {
            resolve(data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getPoolWhitelistData = (poolId: string, network: number) => {
    return new Promise((resolve, reject) => {
        const variables = {
            poolId: poolId,
            networkId: network,
          };
      
          graphQLClient
            .request(GET_POOL_WHITELIST_STATE, variables)
            .then((data: any) => {
              resolve(data);
            })
            .catch((error: any) => {
              reject(error);
            });
    })
}

export const applyToPoolWhitelistFunction = (pool_id: string) => {
    return new Promise((resolve, reject) => {
        const variables = {
            pool_id,
        }

        graphQLClient
            .request(APPLY_TO_POOL_WHITELIST, variables)
            .then((data: any) => {
                resolve(data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const applyToPartnerWhitelistFunction = async (poolId: string, code: string) => {
    return new Promise((resolve, reject) => {
        const variables = {
            poolId: poolId,
            code: code,
        }

        graphQLClient
            .request(APPLY_TO_PARTNER_WHITELIST, variables)
            .then((data: any) => {
                resolve(data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}